<template>
  <div>
    <v-card outlined class="pa-2 ma-4" :loading="loading">
      <template v-if="!loading">
        <v-card-text>
          <v-row v-if="doc && doc.contract">
            <v-col cols="12" sm="12" md="2">
              <div class="title black--text">
                {{ $t("account.whitelabel.data.contract")
                }}<v-chip color="green" class="ml-3" outlined small>{{
  $t("common.active")
}}</v-chip>
              </div>
              <v-btn color="primary" elevation="0" class="mt-3"><v-icon small class="mr-3">mdi-download</v-icon>
                {{ $t("account.whitelabel.data.btnDownload") }}</v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <div class="title">
                {{ $t("account.whitelabel.data.registerDate") }}
              </div>
              <div class="text-p">{{ doc.contract.since | date }}</div>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <div class="title">
                {{ $t("account.whitelabel.data.expirationDate") }}
              </div>
              <div class="text-p">{{ doc.contract.dueDate | date }}</div>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="12" md="2">
              <div class="title black--text">
                {{ $t("account.whitelabel.data.contract")
                }}<v-chip color="red" class="ml-3" outlined small> {{ $t("account.whitelabel.data.pending") }}</v-chip>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <div class="title black--text">
                {{ $t("account.whitelabel.data.countryOriginTitle") }}
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <!-- <div class="title">{{ $t('account.whitelabel.data.countryOrigin') }}</div> -->
              <div class="text-p d-flex justify-start">
                <v-card class="d-flex pa-2" outlined :class="doc && ['Bra', 'Brasil'].includes(doc.origin)
                    ? ''
                    : '-active'
                  ">
                  <div>
                    <v-img src="@/assets/flags/bra.svg" width="30" max-width="30" height="20" contain></v-img>
                  </div>
                  <span class="text-p ml-2 font-weight-bold">Brasil</span>
                </v-card>
                <v-card class="d-flex ml-3 pa-2" outlined :class="doc && ['PER', 'Peru'].includes(doc.origin) ? '' : '-active'
                  ">
                  <div>
                    <v-img src="@/assets/flags/per.svg" width="30" max-width="30" height="20" contain></v-img>
                  </div>
                  <span class="text-p ml-3 font-weight-bold">Perú</span>
                </v-card>
                <v-spacer></v-spacer>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <div class="title black--text">
                {{ $t("account.whitelabel.data.paymentGatewayTitle") }}
              </div>
            </v-col>

            <v-col v-if="masterStore && masterStore.companyInfo && ['openpay', 'openpay'].includes(masterStore.companyInfo.paymentGateway)" class="d-flex">
              <v-img src="https://lion-web-site.s3.amazonaws.com/public/whitelabel/pagarme-logo.svg" width="100"
                max-width="100" height="25" contain class="paymentFlag mr-2"></v-img>
              <v-img paymentFlag src="https://lion-web-site.s3.amazonaws.com/public/whitelabel/openpay-logo.svg" width="100"
                max-width="100" height="25" contain></v-img>

              <!-- <div class="title">{{ $t('account.whitelabel.data.paymentGateway') }}</div> -->
            </v-col>
            <v-col cols="12" sm="12" md="4" class="d-flex align-center" v-else>

              <v-img class="mr-2" src="https://lion-web-site.s3.amazonaws.com/public/whitelabel/pagarme-logo.svg"
                width="100" max-width="100" height="25" contain></v-img>
              <v-img class="paymentFlag" paymentFlag
                src="https://lion-web-site.s3.amazonaws.com/public/whitelabel/openpay-logo.svg" width="100" max-width="100"
                height="20" contain></v-img>

              <!-- <div class="title">{{ $t('account.whitelabel.data.paymentGateway') }}</div> -->
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <div class="title black--text d-flex flex-column">
                {{ $t("account.whitelabel.data.responsible") }}
                <h5 class="caption">
                  {{ $t('account.whitelabel.data.updateResponsible') }}
                  <strong>mediavendors@themediatrade.com</strong>
                </h5>
              </div>
            </v-col>
            <v-col v-if="doc && doc.accountManager" cols="12" sm="12" md="4">
              <div class="title">The Media Trade</div>
              <div class="text-p">{{ doc.accountManager.name }}</div>
              <div class="text-p">{{ doc.accountManager.email }}</div>
              <div class="text-p">{{ doc.accountManager.phone }}</div>
            </v-col>
            <v-col v-if="doc && doc.accountContact" cols="12" sm="12" md="4">
              <div class="title">{{ $root.auth.profile.displayName }}</div>
              <div class="text-p">{{ doc.accountContact.name }}</div>
              <div class="text-p">{{ doc.accountContact.email }}</div>
              <div class="text-p">{{ doc.accountContact.phone }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </template>
    </v-card>

    <v-card outlined class="pa-2 ma-4" v-if="!loading">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <div class="title black--text d-flex flex-column">
              {{ $t("account.whitelabel.data.bankData") }}
              <h5 class="caption">
                {{ $t("account.whitelabel.data.updateBankData") }} <strong>mediavendors@themediatrade.com</strong>
              </h5>
            </div>
          </v-col>
          <v-col v-if="doc && doc.bankAccount" cols="12" sm="12" md="4">
            <div class="title">Banco</div>
            <div class="text-p">
              {{ doc.bankAccount.bankName }} -
              {{
                doc.bankAccount.bankFebrabanCode ||
                doc.bankAccount.bankStripeCode
              }}
            </div>
          </v-col>
          <v-col v-if="doc && doc.bankAccount" cols="12" sm="12" md="4">
            <div class="title">
              {{ $t("account.whitelabel.data.agency/account") }}
            </div>
            <div class="text-p">
              ({{ doc.bankAccount.agency }}) {{ doc.bankAccount.account }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row v-if="!getLoading"><v-col cols="12">
        <v-card color="" elevation="0" class=" ma-4">
          <div class="d-flex align-center justify-space-between mb-4" v-if="!loading">
            <div class="title ml-6">
              {{ $t("account.whitelabel.data.usersManagement.title") }}

              <v-chip v-if="currentPlan" color="info" small outlined class="ml-2">
                {{
                  $tc("account.whitelabel.data.usersManagement.activeOutOf", activeUsers?.length, {
                    actives: activeUsers.length,
                    total: currentCicle?.limits?.users
                  }) }}
              </v-chip>
              <v-chip v-else color="info" small outlined class="ml-2">
                {{ $tc("account.whitelabel.data.usersManagement.activeOutOf", activeUsers?.length, { actives: 0, total: 0 }) }}
              </v-chip>
            </div>
            <div class="d-flex">
              <v-spacer></v-spacer>
              <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined :label="this.$t('account.whitelabel.data.usersManagement.search')
                " single-line dense hide-details></v-text-field>

              <v-dialog :persistent="editBtn == true ? true : false" v-model="formDialog" class="" width="700">
                <template v-if="$root.auth.type.access == 1" v-slot:activator="{ on, attrs }">
                  <v-btn dark v-bind="attrs" v-on="on" color="success" height="40" elevation="0" class="ml-2">{{
                    $t("common.add") }}</v-btn>
                </template>
                <v-card class="mx-auto">
                  <v-card-title class="text-h5 mb-2">
                    {{
                      editBtn == false
                      ? this.$t(
                        "account.whitelabel.data.usersManagement.form.title"
                      )
                      : this.$t(
                        "account.whitelabel.data.usersManagement.form.editTitle"
                      )
                    }}
                  </v-card-title>
                  <v-card-text>
                    <form>
                      <v-text-field v-model="form.name" :label="this.$t(
                        'account.whitelabel.data.usersManagement.form.name'
                      )
                        " required @input="v$.form.name.$touch()" @blur="v$.form.name.$touch()"
                        :error-messages="nameErrors"></v-text-field>
                      <v-text-field :disabled="disabledEmail" v-model="form.email" :label="$t(
                        'account.whitelabel.data.usersManagement.form.email'
                      )
                        " required @input="v$.form.email.$touch()" @blur="v$.form.email.$touch()"
                        :error-messages="emailErrors">
                      </v-text-field>
                      <v-select required @input="v$.form.typeAccess.$touch()" @blur="v$.form.typeAccess.$touch()"
                        :error-messages="typeAccessErrors" v-model="form.typeAccess" :items="sortedTypeAccessNames"
                        :label="this.$t(
                          'account.whitelabel.data.usersManagement.form.typeAccess'
                        )
                          "></v-select>
                      <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelEdit()" class="mr-1">{{ $t('common.cancel') }}</v-btn>
                        <v-btn v-if="editBtn == false" @click="submitNewUser()" :loading="btnLoading" color="success"
                          :disabled="disabledBtn" elevation="0">
                          {{ $t("common.save") }}
                        </v-btn>
                        <v-btn v-else @click="saveEdit()" :loading="btnLoading" color="success" :disabled="disabledBtn"
                          elevation="0">
                          {{ $t("common.editBtn") }}
                        </v-btn>

                      </div>
                    </form>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
          </div>
          <v-card elevation="0" outlined>
            <v-data-table :loading="tableLoading" :headers="headers" :items="getDocuments"  :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 25, 50]
            }" :items-per-page="25"
              :sort-by="['alreadyLoggedIn', 'name']" :sort-desc="[true, false]">
              <template v-slot:[`item.access.profileAccessTypeId`]="{ item }">
                {{ getProfileAccessTypeName(item.access.profileAccessTypeId) }}
              </template>
              <template v-slot:[`item.alreadyLoggedIn`]="{ item }">
                <v-chip label small color="error" v-if="item.access.statusId == 2">{{ $t('product.configurations.status.inactive') }}</v-chip>
                <template v-else>
                  <v-chip label small v-if="item.alreadyLoggedIn && item.alreadyLoggedIn > 0" color="success">{{
                    $t("common.active") }}</v-chip>
                  <v-chip label small v-else>{{
                    $t("common.pending")
                  }}</v-chip>
                </template>
              </template>

              <template v-slot:[`item.createdOn`]="{ item }">
                {{ item.createdOn | dateTimeTz(item.timezone) }}
              </template>
              <template v-slot:[`item.createInfo`]="{ item }">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class=" font-weight-bold" color="grey" dark v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{ item.createdOn | dateTime }}</span>
                </v-tooltip>

              </template>

              <template v-slot:[`item.btn`]="{ item }">
                <div v-if="$root.auth.type.access == 1">

                  <v-btn class="ml-8" icon small @click="openHistory(item)"><v-icon>mdi-account-details</v-icon></v-btn>


                  <v-btn class="ml-8" icon small @click="editUser(item)"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                  <v-btn class="ml-8" icon small @click="openConfirmDialog(item)"><v-icon
                      color="red">mdi-trash-can-outline</v-icon></v-btn>
                </div>
              </template>
            </v-data-table>
            <div class="text-center">
              <v-dialog v-model="confirmDialog" width="500">
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    {{ this.$t(
                      'common.deleteUser'
                    )
                    }}
                  </v-card-title>
                  <div class="px-4">
                    <v-text-field v-model="deleteDialogText"
                      :placeholder="$t('account.whitelabel.data.usersManagement.form.confirmDelete')">
                    </v-text-field>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        :disabled="deleteDialogText !== 'DELETAR' && deleteDialogText !== 'DELETE' && deleteDialogText !== 'ELIMINAR'"
                        color="red" class="white--text" @click="deleteUser()" :loading="deleting">
                        {{ $t('common.remove') }}
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-card>
              </v-dialog>
            </div>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="historyUsers.show" width="720">

      <v-card class="mx-auto" :loading="historyUsers.loading">
        <v-card-title>
          {{ $t('accountSettings.security.loginHistory') }}
          <v-spacer></v-spacer>
          <v-btn @click="historyUsers.show = false" icon small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :items="historyUsers.data" :headers="loginHeaders" v-if="!historyUsers.loading">
            <template v-slot:[`item.createdOn`]="{ item }">
              {{ item.createdOn | dateTime }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span class="green--text" v-if="item.status == 'success'">
                <v-icon size="20" class="mr-2" color="green">mdi-shield-check</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
              <span class="red--text" v-if="item.status == 'blocked'">
                <v-icon size="20" class="mr-2" color="red">mdi-lock-clock</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
              <span class="orange--text" v-if="item.status == 'password_error'">
                <v-icon size="20" class="mr-2" color="orange">mdi-alert-circle-outline</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import { initializeApp } from "firebase/app";

import { getFirestore, doc, updateDoc } from "firebase/firestore";
import config from "@/store/config"
import { mapGetters, mapActions, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, email } from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        name: { required, minLength: minLength(3), maxLength: maxLength(100) },
        email: { required, email },
        typeAccess: { required },
      },
    };
  },
  componets: {

  },

  props: {
    currentPlan: {
      type: Object,
    },
    currentCicle: {
      type: Object
    }
  },
  data() {
    return {
      deleting: false,
      historyUsers: {
        show: false,
        list: false,
        loading: false
      },
      deleteDialogText: "",
      deleteUserObj: null,
      confirmDialog: false,
      form: {
        name: "",
        email: "",
        typeAccess: "",
      },
      typeAccessItems: [
        // {
        //   text: this.$t(
        //     "account.whitelabel.data.usersManagement.form.typeAccessItems.legal"
        //   ),
        //   value: "legal",
        // },
        {
          text: this.$t(
            "account.whitelabel.data.usersManagement.form.typeAccessItems.financial"
          ),
          value: "financial",
        },
        {
          text: this.$t(
            "account.whitelabel.data.usersManagement.form.typeAccessItems.commercial"
          ),
          value: "commercial",
        },
        {
          text: this.$t(
            "account.whitelabel.data.usersManagement.form.typeAccessItems.marketing"
          ),
          value: "marketing",
        },
        // {
        //   text: this.$t(
        //     "account.whitelabel.data.usersManagement.form.typeAccessItems.administrator"
        //   ),
        //   value: "admin",
        // },
        // {
        //   text: this.$t(
        //     "account.whitelabel.data.usersManagement.form.typeAccessItems.creative"
        //   ),
        //   value: "creative",
        // },
        {
          text: this.$t(
            "account.whitelabel.data.usersManagement.form.typeAccessItems.opec"
          ),
          value: "opec",
        },
        {
          text: this.$t(
            "account.whitelabel.data.usersManagement.form.typeAccessItems.moderator"
          ),
          value: "moderator",
        },
        {
          text: this.$t(
            "account.whitelabel.data.usersManagement.form.typeAccessItems.product"
          ),
          value: "product",
        },
      ],
      sortedTypeAccessNames: [],
      search: "",
      formDialog: false,
      editFormDialog: false,
      getDocuments: [],
      usersDocuments: [],
      doc: null,
      loading: false,
      getLoading: false,
      disabledEmail: false,
      editBtn: false,
      btnLoading: false,
      tableLoading: false,
    };
  },
  mounted() {
    this.loadAccount();
    this.loadDocuments();
    console.log('$root.auth.type.access', this.$root.auth.type)
  },
  created() {
    this.sortedTypeAccessNames = this.typeAccessItems
      .slice()
      .sort((a, b) => a.text.localeCompare(b.text));
  },
  computed: {
    ...mapState("groupStores", [
      "masterStore"]
  ),

    activeUsers() {
      return this.getDocuments.filter((item) => {
        return item.alreadyLoggedIn > 0
      })
    },

    disabledBtn() {
      return this.v$.$invalid;
    },
    nameErrors() {
      const errors = [];
      if (!this.v$.form.name.$dirty) return errors;
      this.v$.form.name.minLength.$invalid &&
        errors.push(
          this.$t("accountSettings.personalData.err.minLengthName", {
            count: 3,
          })
        );
      this.v$.form.name.maxLength.$invalid &&
        errors.push(
          this.$t("accountSettings.personalData.err.maxLengthName", {
            count: 100,
          })
        );
      this.v$.form.name.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.name"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.v$.form.email.$dirty) return errors;
      this.v$.form.email.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.email"));
      this.v$.form.email.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.requiredEmail"));
      return errors;
    },
    typeAccessErrors() {
      const errors = [];
      if (!this.v$.form.typeAccess.$dirty) return errors;
      this.v$.form.typeAccess.required.$invalid &&
        errors.push(
          this.$t(
            "account.whitelabel.data.usersManagement.form.errors.typeAccess"
          )
        );
      return errors;
    },
    headers() {
      return [
        // { text: 'ID', value: 'uid' },
        {
          text: this.$t("account.whitelabel.data.usersManagement.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("account.whitelabel.data.usersManagement.email"),
          align: "start",
          sortable: true,
          value: "email",
        },
        {
          text: this.$t("account.whitelabel.data.usersManagement.accessLevel"),
          align: "start",
          sortable: true,
          value: "access.profileAccessTypeId",
        },
        {
          text: this.$t("account.whitelabel.data.usersManagement.status"),
          align: "start",
          sortable: true,
          value: "alreadyLoggedIn",
        },
        {
          text: this.$t("account.whitelabel.data.usersManagement.createdOn"),
          align: "end",
          sortable: true,
          value: "createdOn",
        },
        {
          text: '',
          align: "start",
          sortable: true,
          value: "createInfo",
        },
        {
          text: '',
          align: "end",
          sortable: false,
          value: "btn",
        },

      ];
    },
    loginHeaders() {
      return [
        // { text: 'ID', value: 'uid' },

        { text: this.$t("accountSettings.security.date"), value: "createdOn" },
        { text: this.$t("accountSettings.security.os"), value: "plataform" },
        { text: "IP", value: "remoteAddr" },
        { text: "Status", value: "status", align: "center" },

      ];
    },
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    openHistory(data) {
      this.historyUsers.data = []
      this.historyUsers.loading = true
      this.historyUsers.show = true
      const url = `users/historic?id=${data.id}`;
      this.$axios
        .get(url)
        .then((res) => {
          this.historyUsers.data = res.data.data.list
          this.historyUsers.loading = false

        })
    },

    getProfileAccessTypeName(id) {
      switch (id) {
        case 1:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.administrator');
        case 2:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.moderator');
        case 3:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.commercial');
        case 4:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.marketing');
        case 5:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.financial');
        case 7:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.legal');
        case 9:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.creative');
        case 10:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.opec');
        case 12:
          return this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.product');
        default:
          return "Sem nível de acesso definido";
      }
    },
    loadDocuments(saveFirebase) {
      this.tableLoading = true;
      const url = `users/list/mediavendor`;
      this.$axios
        .get(url)
        .then((response) => {
          if (saveFirebase) {

            const adminUsers = []
            response.data.data.forEach((user) => {
              const userAccess = {
                access: user.access.profileAccessTypeId,
                name: user.name,
                email: user.email
              }
              adminUsers.push(userAccess)
            })
            const firebase = initializeApp(config);
      const db = getFirestore(firebase);

            const masterRef = doc(db, "stores", this.masterStore.id);

            // Set the "capital" field of the city 'DC'
            updateDoc(masterRef, {
              adminUsers: adminUsers
            });
          }
          console.log("doc", response);
          this.getDocuments = response.data.data;
          this.tableLoading = false;
        });
    },
    loadAccount() {
      this.loading = true;
      const url = `whitelabel/get`;
      this.$axios
        .get(url)
        .then((response) => {
          console.log("doc", response);
          this.doc = response.data.data;
          console.log('this.doc', this.doc)
          this.loading = false;
          this.$emit('update-doc', response.data.data)
        });
    },
    submitNewUser() {
      this.btnLoading = true;
      let form = {
        name: this.form.name,
        email: this.form.email,
        typeAccess: this.form.typeAccess,
        noMessage: true
      };
      const url = `users/register/mediavendor`;
      this.v$.$touch();
      if (!this.v$.$invalid) {
        this.$axios
          .post(url, form)
          .then((res) => {
            console.log("resposta do submitUser", res);
            this.loadDocuments(true);
          })
          .catch((err) => {
            this.btnLoading = false;
          })
          .then(() => {
            this.v$.$reset();
            this.form = {
              name: "",
              email: "",
              typeAccess: "",
              
            };
            this.btnLoading = false;
            this.formDialog = false;
            this.showSnack({
              text: this.$t('account.whitelabel.data.usersManagement.form.snackMessages.userAdded'),
              color: "success",
              timeout: 4000,
              icon: "mdi-check",
            });
          });
        //}
      }
    },
    editUser(item) {
      console.log("snap to edit", item);
      this.form = JSON.parse(JSON.stringify(item));
      this.disabledEmail = true;
      this.editBtn = true;
      this.formDialog = true;
    },
    openConfirmDialog(item) {
      const form = {
        id: item.id,
        statusId: 2,
      };
      this.deleteUserObj = form;
      this.confirmDialog = true;
    },
    deleteUser() {
      this.deleting = true
      const form = this.deleteUserObj;
      const url = `users/mediavendor`;
      this.$axios
        .put(url, form)
        .then(() => {
          console.log("deletedForm", form);
          this.loadDocuments(true);
        })
        .catch((err) => {
          const error = err.data.errors;
          console.error("ERR", error);
        })
        .then(() => {
          this.deleting = false
          this.showSnack({
            text: this.$t('account.whitelabel.data.usersManagement.form.snackMessages.userRemoved'),
            color: "success",
            timeout: 4000,
            icon: "mdi-check",
          });
          this.confirmDialog = false;
          this.deleteDialogText = "";
        });
    },
    cancelEdit() {
      this.v$.$reset();
      this.form = {
        name: "",
        email: "",
        typeAccess: "",
      };
      this.disabledEmail = false;
      this.editBtn = false;
      this.formDialog = false;
    },
    saveEdit() {
      this.btnLoading = true;
      let form = {
        id: this.form.id,
        name: this.form.name,
        typeAccess: this.form.typeAccess,
        noMessage: true
      };
      const url = `users/mediavendor`;
      this.v$.$touch();
      if (!this.v$.$invalid) {
        console.log("formEdit", form);
        this.$axios
          .put(url, form, {
          })
          .then((res) => {
            console.log(res);
            this.loadDocuments(true);
          })
          .catch((err) => {
            this.loading = false;
            const error = err.response.data.errors;
            console.error("ERR", error);
          })
          .then(() => {
            this.v$.$reset();
            this.form = {
              name: "",
              email: "",
              typeAccess: "",
            };
            (this.editBtn = false),
              (this.disabledEmail = false),
              (this.formDialog = false),
              (this.btnLoading = false);
            this.showSnack({
              text: this.$t('account.whitelabel.data.usersManagement.form.snackMessages.userEdited'),
              color: "success",
              timeout: 4000,
              icon: "mdi-check",
            });
          });
        //}
      }
    },
  },

};
</script>
<style scoped>
.paymentFlag {
  filter: opacity(0.75) saturate(0);
}

.-active {
  filter: opacity(0.75) saturate(0);
}
</style>
